import React from 'react';
import classNames from 'classnames';
import Button, { ButtonProps } from './Button';

const DestructiveButton = ({ className, children, ...rest }: ButtonProps) => (
  <Button className={classNames(className, 'destructive')} {...rest}>
    {children}
  </Button>
);

export default DestructiveButton;
